div(v-if='slots.link' @click='login' data-test='login.slot')
  slot(name='link')
FairplayerButtonVue(v-else :icon='icon' :expand='expandButton' :secondary='secondaryButton' :text='t(translateKey)' @click='login' data-test='login.button')
